import React from "react";

const PlaceholderBar = ({ classname }) => {
	return <div className={`${classname}`} />;
};

export { PlaceholderBar };
export default PlaceholderBar;
